/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Docx_DocxInputs */



/**
* | output |
* | --- |
* | "DocX (.docX)" |
*
* @param {Docx_DocxInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const docx_docx = /** @type {((inputs?: Docx_DocxInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Docx_DocxInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("DocX (.docX)")
	if (locale === "de") return /** @type {LocalizedString} */ ("DocX (.docX)")
	if (locale === "it") return /** @type {LocalizedString} */ ("DocX (.docX)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("DocX (.docX)")
	if (locale === "es") return /** @type {LocalizedString} */ ("DocX (.docX)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("DocX (.docX)")
	if (locale === "ja") return /** @type {LocalizedString} */ ("DocX (.docX)")
	if (locale === "hi") return /** @type {LocalizedString} */ ("DocX (.docX)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("DocX (.docX)")
	return /** @type {LocalizedString} */ ("DocX (.docX)")
});